import React, { useState, useEffect } from "react";
import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  InputNumber,
  Popconfirm,
  Select,
  Space,
  message,
  Tag,
} from "antd";

import * as Icons from "@ant-design/icons";
import {
  fetchTunjangan,
  createTunjangan,
  updateTunjangan,
  deleteTunjangan,
} from "../../api/master/Tunjangan";
import { dropdownTunjangan } from "../../api/master/MasterTunjangan";
import { getDropdownJabatan } from "../../api/master/Jabatan";

const { Option } = Select;

const TunjanganPage = () => {
  const sessiData = JSON.parse(sessionStorage.getItem("user"));
  const [editForm] = Form.useForm();
  const [modalForm] = Form.useForm();

  const [data, setData] = useState([]);
  const [jabatanList, setJabatanList] = useState([]);
  const [editingKey, setEditingKey] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [tunjanganList, SetTunjanganList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Cari ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<Icons.SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Cari
        </Button>
        <Button
          onClick={() => {
            handleReset(clearFilters);
            confirm({ closeDropdown: true });
          }}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icons.SearchOutlined
        style={{ color: filtered ? "#1890ff" : undefined }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
    render: (text) =>
      searchedColumn === dataIndex ? (
        <span style={{ backgroundColor: "#ffc069", padding: 0 }}>{text}</span>
      ) : (
        text
      ),
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
    setSearchedColumn("");
  };

  const loadData = async () => {
    setLoading(true);
    try {
      const apiData = await fetchTunjangan();
      const mappedData = apiData.map((item) => ({
        key: item.tnjb_id.toString(),
        namaTunjangan: item.tnj_nama_tunjangan,
        jumlah: Number(item.tnjb_jumlah),
        jabatanId: item.tnjb_jabatan_id,
        jabatanNama: item.jbt_nama_jabatan.trim(),
        status: item.tnjb_status,
      }));

      setData(mappedData);
    } catch (error) {
      message.error("Gagal memuat data");
    } finally {
      setLoading(false);
    }
  };

  const loadMasterTunjangan = async () => {
    try {
      const res = await dropdownTunjangan();
      if (res.data.status) {
        SetTunjanganList(res.data.data);
      } else {
        message.error("Gagal memuat data tunjangan");
      }
    } catch (error) {
      message.error("Gagal memuat data");
    }
  };

  const loadMasterJabatan = async () => {
    try {
      const res = await getDropdownJabatan();
      if (res) {
        setJabatanList(res);
      } else {
        message.error("Gagal memuat data tunjangan");
      }
    } catch (error) {
      message.error("Gagal memuat data");
    }
  };

  useEffect(() => {
    loadData();
    loadMasterTunjangan();
    loadMasterJabatan();
  }, []);

  const isEditing = (record) => record.key === editingKey;

  const edit = (record) => {
    editForm.setFieldsValue({ ...record });
    setEditingKey(record.key);
  };

  const cancel = () => {
    setEditingKey("");
  };

  const save = async (key) => {
    setSaving(true);
    try {
      const row = await editForm.validateFields();
      const item = data.find((d) => d.key === key);
      const payload = {
        tnjb_jumlah: row.jumlah,
        tnjb_status: row.status,
        tnjb_update_by: sessiData[0].user[0].fullname,
      };

      const result = await updateTunjangan(item.key, payload);
      if (result.status) {
        message.success("Tunjangan berhasil diperbarui");
        setEditingKey("");
        await loadData();
      } else {
        message.error("Gagal memperbarui tunjangan");
      }
    } catch (err) {
      message.error("Terjadi kesalahan validasi");
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (key) => {
    try {
      const result = await deleteTunjangan(key);
      if (result.status) {
        message.success("Tunjangan berhasil dihapus");
        loadData();
      } else {
        message.error("Gagal menghapus tunjangan");
      }
    } catch (error) {
      message.error("Terjadi kesalahan saat menghapus");
    }
  };

  const showModal = () => {
    setIsModalVisible(true);
    modalForm.resetFields();
  };

  const handleModalOk = async () => {
    setSaving(true);
    try {
      const values = await modalForm.validateFields();
      const payload = {
        tnjb_tunjanganid: values.tunjanganId,
        tnjb_jumlah: values.jumlah,
        tnjb_jabatan_id: values.jabatanId,
        tnjb_status: values.status,
        tnjb_created_by: sessiData[0].user[0].fullname,
      };

      const result = await createTunjangan(payload);
      if (result.status) {
        message.success("Tunjangan berhasil ditambahkan");
        modalForm.resetFields();
        setIsModalVisible(false);
        await loadData();
      } else {
        message.error("Gagal menambahkan tunjangan");
      }
    } catch (error) {
      message.error("Terjadi kesalahan saat menambahkan");
    } finally {
      setSaving(false);
    }
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
    modalForm.resetFields();
  };

  const columns = [
    {
      title: "Jabatan",
      dataIndex: "jabatanNama",
      filters: jabatanList.map((j) => ({
        text: j.jbt_nama_jabatan,
        value: j.jbt_nama_jabatan,
      })),
      onFilter: (value, record) => record.jabatanNama === value,
    },
    {
      title: "Nama Tunjangan",
      dataIndex: "namaTunjangan",
      key: "namaTunjangan",
      ...getColumnSearchProps("namaTunjangan"),
    },
    {
      title: "Jumlah",
      dataIndex: "jumlah",
      editable: true,
      render: (val) => `Rp ${val.toLocaleString()}`,
      sorter: (a, b) => a.jumlah - b.jumlah,
    },
    {
      title: "Status",
      dataIndex: "status",
      editable: true,
      render: (val) => (
        <Tag color={val === "Aktif" ? "green" : "red"}>{val}</Tag>
      ),
      filters: [
        { text: "Aktif", value: "Aktif" },
        { text: "Tidak Aktif", value: "Tidak Aktif" },
      ],
      onFilter: (value, record) => record.status === value,
    },

    {
      title: "Aksi",
      dataIndex: "aksi",
      width: 100,
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <Space>
            <Button
              onClick={() => save(record.key)}
              type="link"
              loading={saving}
            >
              Simpan
            </Button>
            <Button onClick={cancel} type="link">
              Batal
            </Button>
          </Space>
        ) : (
          <Space>
            <Button
              disabled={editingKey !== ""}
              onClick={() => edit(record)}
              type="link"
            >
              Edit
            </Button>
            <Popconfirm
              title="Yakin ingin menghapus?"
              onConfirm={() => handleDelete(record.key)}
            >
              <Button type="link" danger>
                Hapus
              </Button>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];

  const mergedColumns = columns.map((col) => {
    if (!col.editable) return col;
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.dataIndex === "jumlah" ? "number" : "text",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
  }) => {
    let inputNode;
    if (dataIndex === "status") {
      inputNode = (
        <Select>
          <Option value="Aktif">Aktif</Option>
          <Option value="Tidak Aktif">Tidak Aktif</Option>
        </Select>
      );
    } else {
      inputNode =
        inputType === "number" ? (
          <InputNumber
            min={0}
            step={0.01}
            style={{ width: "100%" }}
            formatter={(value) =>
              value ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ""
            }
            parser={(value) => value.replace(/Rp\s?|(,*)/g, "")}
          />
        ) : (
          <Input />
        );
    }

    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            style={{ margin: 0 }}
            rules={[{ required: true, message: `Isi ${title.toLowerCase()}` }]}
          >
            {inputNode}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 16 }}>
        <Button type="primary" onClick={showModal}>
          Tambah Tunjangan
        </Button>
      </div>

      <Form form={editForm} component={false}>
        <Table
          loading={loading}
          components={{ body: { cell: EditableCell } }}
          bordered
          dataSource={data}
          columns={mergedColumns}
          rowClassName="editable-row"
          pagination={{
            pageSizeOptions: ["10", "20", "40", "60"],
            showSizeChanger: true,
            defaultPageSize: 20,
          }}
          scroll={{ x: "max-content" }}
        />
      </Form>

      <Modal
        title="Tambah Tunjangan Jabatan"
        visible={isModalVisible}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        okText="Simpan"
        cancelText="Batal"
        confirmLoading={saving}
      >
        <Form form={modalForm} layout="vertical">
          <Form.Item
            name="jabatanId"
            label="Jabatan"
            rules={[{ required: true, message: "Pilih jabatan!" }]}
          >
            <Select
              showSearch
              placeholder="Pilih Jabatan"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
            >
              {jabatanList.map((j) => (
                <Option key={j.jbt_id_jabatan} value={j.jbt_id_jabatan}>
                  {j.jbt_nama_jabatan}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="tunjanganId"
            label="Nama Tunjangan"
            rules={[{ required: true, message: "Pilih nama tunjangan!" }]}
          >
            <Select
              showSearch
              placeholder="Pilih Tunjangan"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
            >
              {tunjanganList.map((t) => (
                <Option key={t.tnj_id} value={t.tnj_id}>
                  {t.tnj_nama_tunjangan}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="jumlah"
            label="Jumlah"
            rules={[{ required: true, message: "Masukkan jumlah tunjangan!" }]}
          >
            <InputNumber
              min={0}
              step={0.01}
              style={{ width: "100%" }}
              formatter={(value) =>
                value ? `Rp ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ""
              }
              parser={(value) => value.replace(/Rp\s?|(,*)/g, "")}
            />
          </Form.Item>

          <Form.Item
            name="status"
            label="Status"
            rules={[{ required: true, message: "Pilih status!" }]}
          >
            <Select placeholder="Pilih Status">
              <Option value="Aktif">Aktif</Option>
              <Option value="Tidak Aktif">Tidak Aktif</Option>
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default TunjanganPage;
